import { render, staticRenderFns } from "./InputMaterialIdentificacao.vue?vue&type=template&id=6c48fb86&"
import script from "./InputMaterialIdentificacao.vue?vue&type=script&lang=js&"
export * from "./InputMaterialIdentificacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports